// 3D-значки в «желейном» стиле Turkido (тот же набор, что значки озвучки
// audio-icon-jelly / slow-icon-jelly). Подменяют эмодзи в кнопках и плашках:
// по эмодзи ищем картинку, если её нет — рисуем само эмодзи.
// Inline-стили: телефон пользователя может держать устаревший CSS-бандл.
// Обычный <img>, а не next/image: картинки крошечные и повторяются.
const JELLY_ICONS: Record<string, string> = {
  '✈️': '/brand/icons/plane.jpg',
  '👋': '/brand/icons/wave.jpg',
  '🚕': '/brand/icons/taxi.jpg',
  '🏨': '/brand/icons/hotel.jpg',
  '☕': '/brand/icons/cafe.jpg',
  '🛍️': '/brand/icons/bag.jpg',
  '🧭': '/brand/icons/compass.jpg',
  '📖': '/brand/icons/book.jpg',
  '🎭': '/brand/icons/masks.jpg',
  '🏡': '/brand/icons/house.jpg',
  '💼': '/brand/icons/briefcase.jpg',
  '💡': '/brand/icons/bulb.jpg',
  '🎓': '/brand/icons/cap.jpg',
  '🔁': '/brand/icons/repeat.jpg',
  '🔥': '/brand/icons/flame.jpg',
  '📚': '/brand/icons/books.jpg',
  '⭐': '/brand/icons/star.jpg',
  '🎯': '/brand/icons/target.jpg',
  '🏆': '/brand/icons/trophy.jpg',
  '💬': '/brand/icons/chat.jpg',
  '🌅': '/brand/icons/sunrise.jpg',
  '🧊': '/brand/icons/ice.jpg',
  '🎁': '/brand/icons/gift.jpg',
  '👁': '/brand/icons/eye.jpg',
  '📊': '/brand/icons/chart.jpg',
  '🎉': '/brand/icons/party.jpg',
  '⚡': '/brand/icons/bolt.jpg',
  '✨': '/brand/icons/sparkles.jpg',
  // Значки достижений (иконки берутся из таблицы badges / lib/activity.ts).
  '📘': '/brand/icons/book-blue.jpg',
  '📗': '/brand/icons/book-green.jpg',
  '🏔': '/brand/icons/mountain.jpg',
  '💎': '/brand/icons/diamond.jpg',
  // Партия 2026-09-18 (Glif, по образцам chat.jpg/books.jpg).
  '🔢': '/brand/icons/numbers.jpg',
  '🌱': '/brand/icons/sprout.jpg',
  '📐': '/brand/icons/set-square.jpg',
  '🏁': '/brand/icons/flag.jpg',
  '🎨': '/brand/icons/palette.jpg',
  '▶️': '/brand/icons/play.jpg',
  // Партия игр 2026-09-18 (Glif, по образцам numbers.jpg/chat.jpg).
  '👂': '/brand/icons/ear.jpg',
  '🎴': '/brand/icons/cards.jpg',
  '🧩': '/brand/icons/puzzle.jpg',
  '🔧': '/brand/icons/wrench.jpg',
  '🪙': '/brand/icons/coin.jpg',
  '🎮': '/brand/icons/gamepad.jpg',
  // «Турецкий для жизни» 2026-09-22 (Glif, по образцам taxi.jpg/hotel.jpg/bulb.jpg).
  // 🏠 — тот же домик, что у цели онбординга 🏡.
  '🏠': '/brand/icons/house.jpg',
  '📶': '/brand/icons/signal.jpg',
  '🏦': '/brand/icons/bank.jpg',
  '🪪': '/brand/icons/id-card.jpg',
  '🩺': '/brand/icons/stethoscope.jpg',
  '🏢': '/brand/icons/apartment.jpg',
  '📜': '/brand/icons/scroll.jpg',
  // «Своя ситуация» — карандаш по записке (Glif, та же партия).
  '✍️': '/brand/icons/pencil.jpg',
  // Кнопки разговорника «Поделиться» и «Распечатать» (Glif, та же партия).
  '📤': '/brand/icons/share.jpg',
  '🖨': '/brand/icons/printer.jpg',
  // Характер собеседника (lib/personas.ts) и замок платного — Glif, та же партия.
  '🙂': '/brand/icons/persona-friendly.jpg',
  '🎩': '/brand/icons/persona-polite.jpg',
  '⏱️': '/brand/icons/persona-hurry.jpg',
  '😤': '/brand/icons/persona-annoyed.jpg',
  '🤝': '/brand/icons/persona-bargain.jpg',
  '🔄': '/brand/icons/persona-tandem.jpg',
  '🔒': '/brand/icons/lock.jpg',
  // Перевод по фотографии «Перевод по фото» (Glif, та же партия, 04.10.2026).
  '📷': '/brand/icons/camera.jpg',
  // Плитка «Выбрать снимок» на /photo (Glif, та же партия, задача 51 из Telegram).
  '🖼️': '/brand/icons/gallery.jpg',
  // Плитка «Алфавит» на дашборде (Glif, по образцам numbers.jpg/books.jpg, 08.10.2026).
  '🔤': '/brand/icons/alphabet.jpg',
  // Игра «Личные окончания» (Glif, по образцам wave.jpg/persona-friendly.jpg, 19.10.2026).
  '🙋': '/brand/icons/point-self.jpg',
  // Планета-логотип: та же, что на кнопке «Спроси Turkido».
  '🌍': '/brand/logo-orb-v2.png',
}

export function hasJellyIcon(emoji: string): boolean {
  return emoji in JELLY_ICONS
}

export function JellyIcon({
  emoji,
  size = 28,
  radius,
}: {
  emoji: string
  size?: number
  // По умолчанию — скруглённый квадрат (~27% стороны); 9999 — круг.
  radius?: number
}) {
  const src = JELLY_ICONS[emoji] ?? JELLY_ICONS[emoji.replace('\uFE0F', '')]
  // Мелкий значок (внутри строки текста, в ячейке календаря) — без рамки и
  // тени, иначе выглядит тяжело.
  const small = size < 22
  if (!src) {
    return (
      <span aria-hidden style={{ fontSize: Math.round(size * 0.8), lineHeight: 1, flexShrink: 0 }}>
        {emoji}
      </span>
    )
  }
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-block',
        flexShrink: 0,
        width: size,
        height: size,
        borderRadius: radius ?? Math.round(size * 0.27),
        overflow: 'hidden',
        border: small ? undefined : '1px solid oklch(0.62 0.12 240 / 0.35)',
        boxShadow: small ? undefined : '0 4px 12px -6px oklch(0.55 0.2 255 / 0.8)',
        verticalAlign: small ? '-0.2em' : 'middle',
      }}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={src} alt="" width={size} height={size} style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }} />
    </span>
  )
}
